import React from "react";
 import { Widget } from "./components/AffinityWidget/Widget/Widget";
function App() {
  let widgetId = ''
  const queryString = window.location.search.slice(1);
  let params = '';
  if (queryString.includes('id')) {
    params = new URLSearchParams(queryString);
    widgetId = params.get('id')
  } 
  
  return (
    <>
    
    <Widget widgetId={widgetId} />
       </>
  );
}

export default App;
